<script setup>
const seoTitle = "";

const seoDescription = "";

// const ogImageTitle = "Zarezerwuj wyjątkowy pobyt już dziś!";

// defineOgImageComponent("Stary", {
//   title: ogImageTitle,
//   image: "/layout/z_lotu_ptaka.jpg",
//   imageAlt: "Rezerwacja pobytu w Starym Młynie",
// });

useSeoMeta({
  title: seoTitle,
  description: seoDescription,
});

const contactFormRef = ref(null);

async function sendEmail(form) {
  try {
    contactFormRef.value.status = "loading";

    const response = await $fetch("/api/mail", {
      method: "POST",
      body: {
        subject: "Nowa wiadomość z TurboWeb",
        text: form.message + "\n\nTelefon: " + form.phone,
        replyToEmail: form.email,
        replyToName: form.firstName,
      },
    });
  } catch (error) {
    contactFormRef.value.status = "error";
  } finally {
    contactFormRef.value.status = "success";
  }
}
</script>
<template>
  <main class="antialiased text-gray-800 grid grid-cols-1 md:grid-cols-2 items-center">
    <!-- HERO: Pełnoekranowe tło z overlayem -->
    <section class="aspect-square">
      <FlexuilibMagicLottieLcp src="/lottie/contact.json" />
    </section>

    <!-- FORMULARZ: Karta na białym tle wysunięta tuż poniżej hero -->

    <!-- Nagłówek formularza -->

    <!-- Sam formularz -->
    <ContactForm
      critical
      ref="contactFormRef"
      class="px-4 md:px-32 py-12"
      @submitted="sendEmail"
    />
  </main>
</template>
